import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { consumeGuestLink } from '@/api/auth'
import ROUTES from '@/routes/routes'
import { useDispatch } from 'react-redux'
import { updateUser } from '@/redux/slices/userSlice'
import { AppDispatch } from '@/redux/store'
import { UserRole } from '@/constants/room'

const GuestPage = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    const token = searchParams.get('token') || ''
    const displayName = searchParams.get('name') || undefined

    if (!token) {
      setError('Missing token')
      return
    }
    ;(async () => {
      try {
        const { user, room_id, invite_code } = await consumeGuestLink(
          token,
          displayName
        )
        dispatch(updateUser(user))

        if (user?.role === UserRole.Student) {
          if (room_id) {
            navigate(ROUTES.STUDENT.WAITING_ROOM(room_id, invite_code), {
              replace: true,
            })
          } else {
            navigate(ROUTES.STUDENT.DASHBOARD, { replace: true })
          }
        } else if (user?.role === UserRole.Professor) {
          if (room_id) {
            const targetRoute = ROUTES.PROFESSOR.ROOM_DETAILS(room_id)
            navigate(targetRoute, { replace: true })
          } else {
            navigate(ROUTES.PROFESSOR.ROOMS, { replace: true })
          }
        } else {
          navigate(ROUTES.ROOT, { replace: true })
        }
      } catch (e: any) {
        setError(e?.message || 'Failed to use guest link')
      }
    })()
  }, [navigate, searchParams])

  if (error) return <div className='p-4 text-red-600'>{error}</div>
  return <div className='p-4'>Signing you in…</div>
}

export default GuestPage
